// ============================================================
//  ROVERS ACCESS LIMITED — dummydata.js
//  Learn | Trade | Grow
// ============================================================

export const homeAbout = [
  {
    id: 1,
    cover: "https://img.icons8.com/dotty/80/ffffff/candlestick-chart.png",
    title: "Practical Trading Education",
    desc: "Our second-to-none practical and technology-based program gives you the edge you need to trade Forex, Futures and Options with confidence.",
  },
  {
    id: 2,
    cover: "https://img.icons8.com/ios/80/ffffff/diploma.png",
    title: "Earn a Trading Certificate",
    desc: "Complete our Signature Programme and earn an industry-recognized certificate that validates your market knowledge and trading skills.",
  },
  {
    id: 3,
    cover: "https://img.icons8.com/ios/80/ffffff/mentor.png",
    title: "One-on-One Mentorship",
    desc: "Our small-class setup enables direct instructor engagement. Real traders guide you through live market conditions — not just slides.",
  },
]

export const awrapper = [
  {
    cover: "https://img.icons8.com/external-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto/80/ffffff/external-graduation-education-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto.png",
    data: "1,200+",
    title: "GRADUATES TRAINED",
  },
  {
    cover: "https://img.icons8.com/ios/80/ffffff/athlete.png",
    data: "5+",
    title: "EXPERT MENTORS",
  },
  {
    cover: "https://img.icons8.com/external-outline-icons-maxicons/80/ffffff/external-calender-insurance-outline-outline-icons-maxicons.png",
    data: "4",
    title: "TRAINING PROGRAMS",
  },
  {
    cover: "https://img.icons8.com/ios/80/ffffff/macbook-idea--v3.png",
    data: "10+",
    title: "YEARS EXPERIENCE",
  },
]

export const coursesCard = [
  {
    id: 1,
    cover: "../images/courses/c1.png",
    coursesName: "Beginner Trading Course",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Mr. Ali",
        totalTime: "4 weeks · Beginner",
      },
    ],
    priceAll: "KES 49,000 Full",
    pricePer: "Flexible payment",
  },
  {
    id: 2,
    cover: "../images/courses/c2.png",
    coursesName: "Intermediate Trader Program",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Mr. Ali",
        totalTime: "6 weeks · Intermediate",
      },
    ],
    priceAll: "KES 79,000 Full",
    pricePer: "Flexible payment",
  },
  {
    id: 3,
    cover: "../images/courses/c3.png",
    coursesName: "Professional Mentorship Program",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Mr. Ali",
        totalTime: "12 weeks · Advanced",
      },
    ],
    priceAll: "KES 109,000 Full",
    pricePer: "Flexible payment",
  },
  {
    id: 4,
    cover: "../images/courses/c4.png",
    coursesName: "Signature Programme — Core",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Mr. Ali",
        totalTime: "8 weeks · All levels",
      },
    ],
    priceAll: "KES 149,000 Full",
    pricePer: "Flexible payment",
  },
  {
    id: 5,
    cover: "../images/courses/c5.png",
    coursesName: "Forex & Currency Markets",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Mr. Ali",
        totalTime: "3 weeks · Beginner",
      },
    ],
    priceAll: "KES 49,000 Full",
    pricePer: "Flexible payment",
  },
  {
    id: 6,
    cover: "../images/courses/c6.png",
    coursesName: "Futures & Options Trading",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Mr. Ali",
        totalTime: "6 weeks · Intermediate",
      },
    ],
    priceAll: "KES 79,000 Full",
    pricePer: "Flexible payment",
  },
  {
    id: 7,
    cover: "../images/courses/c7.png",
    coursesName: "Technical Analysis Masterclass",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Mr. Ali",
        totalTime: "4 weeks · Intermediate",
      },
    ],
    priceAll: "KES 59,000 Full",
    pricePer: "Flexible payment",
  },
  {
    id: 8,
    cover: "../images/courses/c8.png",
    coursesName: "Risk Management & Trading Psychology",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Mr. Ali",
        totalTime: "2 weeks · All levels",
      },
    ],
    priceAll: "KES 39,000 Full",
    pricePer: "Flexible payment",
  },
  {
    id: 9,
    cover: "../images/courses/c9.png",
    coursesName: "Corporate Financial Literacy Workshop",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Mr. Ali",
        totalTime: "1–2 days · Teams",
      },
    ],
    priceAll: "Custom Pricing",
    pricePer: "Contact us",
  },
]

export const online = [
  {
    cover: "./images/courses/online/o1.png",
    hoverCover: "./images/courses/online/o1.1.png",
    courseName: "Forex Trading",
    course: "Core Programme",
  },
  {
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
    courseName: "Futures & Options",
    course: "Advanced Track",
  },
  {
    cover: "./images/courses/online/o3.png",
    hoverCover: "./images/courses/online/o3.1.png",
    courseName: "Technical Analysis",
    course: "Chart Mastery",
  },
  {
    cover: "./images/courses/online/o4.png",
    hoverCover: "./images/courses/online/o4.1.png",
    courseName: "Risk Management",
    course: "Capital Preservation",
  },
  {
    cover: "./images/courses/online/o5.png",
    hoverCover: "./images/courses/online/o5.1.png",
    courseName: "Trading Psychology",
    course: "Mindset Training",
  },
  {
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
    courseName: "Market Structure",
    course: "Price Action",
  },
  {
    cover: "./images/courses/online/o7.png",
    hoverCover: "./images/courses/online/o7.1.png",
    courseName: "Demand & Supply Zones",
    course: "Zone Analysis",
  },
  {
    cover: "./images/courses/online/o8.png",
    hoverCover: "./images/courses/online/o8.1.png",
    courseName: "Trend Analysis",
    course: "Trend Trading",
  },
  {
    cover: "./images/courses/online/o9.png",
    hoverCover: "./images/courses/online/o9.1.png",
    courseName: "Commodities & Indices",
    course: "Global Markets",
  },
  {
    cover: "./images/courses/online/o10.png",
    hoverCover: "./images/courses/online/o10.1.png",
    courseName: "Live Trading Sessions",
    course: "Real-Time Practice",
  },
  {
    cover: "./images/courses/online/o11.png",
    hoverCover: "./images/courses/online/o11.1.png",
    courseName: "Corporate Workshops",
    course: "Team Training",
  },
  {
    cover: "./images/courses/online/o12.png",
    hoverCover: "./images/courses/online/o12.1.png",
    courseName: "Online Mentorship",
    course: "Remote Learning",
  },
]

export const team = [
  {
    cover: "./images/team/t1.webp",
    name: "Mr. Ali",
    work: "FOUNDER & HEAD OF TRADING EDUCATION",
  },
  {
    cover: "./images/team/t2.webp",
    name: "Operations Manager",
    work: "ADMINISTRATION & STUDENT SUPPORT",
  },
  {
    cover: "./images/team/t3.webp",
    name: "Senior Mentor",
    work: "LIVE TRADING & MARKET ANALYSIS",
  },
  {
    cover: "./images/team/t4.webp",
    name: "Curriculum Developer",
    work: "COURSE DESIGN & CONTENT",
  },
  {
    cover: "./images/team/t5.webp",
    name: "Risk Coach",
    work: "RISK MANAGEMENT SPECIALIST",
  },
  {
    cover: "./images/team/t6.webp",
    name: "Technology Lead",
    work: "PLATFORMS & DIGITAL LEARNING",
  },
  {
    cover: "./images/team/t7.webp",
    name: "Student Success Lead",
    work: "MENTORSHIP & PERFORMANCE TRACKING",
  },
  {
    cover: "./images/team/t8.webp",
    name: "Community Manager",
    work: "TRADER NETWORK & OUTREACH",
  },
]

export const price = [
  {
    name: "BEGINNER COURSE",
    price: "49K",
    desc: "4-week program covering Forex fundamentals, platform orientation, trading terminologies, and introduction to technical analysis. Ideal for complete novices.",
  },
  {
    name: "INTERMEDIATE PROGRAM",
    price: "79K",
    desc: "6-week advanced course covering chart analysis, demand & supply zones, trend trading, and strategy development for traders who know the basics.",
  },
  {
    name: "PROFESSIONAL MENTORSHIP",
    price: "109K",
    desc: "12-week live mentorship and practical market execution program. One-on-one coaching, trading journals, and real-time performance tracking included.",
  },
  {
    name: "SIGNATURE PROGRAMME",
    price: "149K",
    desc: "Our flagship all-inclusive course covering the complete curriculum: Forex, Futures & Options, risk management, psychology, and live trading sessions.",
  },
]

export const faq = [
  {
    title: "What is the Rovers Access Signature Programme?",
    desc: "The Signature Programme is our flagship trading course covering the complete curriculum — from trading platform orientation and market structure to demand/supply zones, trend analysis, and live trading sessions. It is designed for both beginners and those looking to sharpen their skills.",
  },
  {
    title: "Do I need prior trading experience to enroll?",
    desc: "No prior experience is needed. Our Beginner Trading Course starts from the ground up, covering everything from what a trading platform looks like to how to read a live chart. We welcome complete novices as well as experienced traders.",
  },
  {
    title: "Is the training available online or only in-person?",
    desc: "We offer both in-person training at our Victoria Plaza, Westlands Nairobi office and flexible online learning accessible from anywhere. Contact us at info@rovers.ke or +254 723 000 200 to discuss the option that suits you.",
  },
  {
    title: "What markets does Rovers Access cover?",
    desc: "Our programmes cover Forex (currency pairs), Futures, Options, Commodities, Indices, and CFDs. You learn to read live charts, manage real risk, and execute trades across all major global financial markets.",
  },
  {
    title: "How is Rovers Access different from other trading courses?",
    desc: "We focus entirely on practical, knowledge-based curriculum — no social media hype, no unrealistic return promises. Small-class sizes ensure one-on-one instructor attention. Our motto is clear: GAMBLING IS NOT TRADING.",
  },
  {
    title: "What are the training hours and how do I get started?",
    desc: "Training runs Monday–Friday 8:00 AM–6:00 PM and Saturday 9:00 AM–1:00 PM (EAT, UTC+3). To get started, reach us on WhatsApp, email info@rovers.ke, call +254 723 000 200, or visit www.rovers.ke.",
  },
]

export const blog = [
  {
    id: 1,
    type: "Trading Insight",
    date: "JAN. 10, 2026",
    com: "5 COMMENTS",
    title: "Why Gambling Is Not Trading — The Rovers Access Philosophy",
    desc: "Understanding the fundamental difference between gambling and disciplined, rule-based trading is the first step every serious market participant must take.",
    cover: "../images/blog/b1.webp",
  },
  {
    id: 2,
    type: "Market Analysis",
    date: "FEB. 14, 2026",
    com: "8 COMMENTS",
    title: "Mastering Demand & Supply Zones in Forex Markets",
    desc: "Demand and supply zones are the backbone of price action trading. Learn how to identify strong and weak zones and how to place your proximal and distal lines correctly.",
    cover: "../images/blog/b2.webp",
  },
  {
    id: 3,
    type: "Trading Psychology",
    date: "MAR. 03, 2026",
    com: "12 COMMENTS",
    title: "Trading Psychology: How to Stay Disciplined When Markets Move Against You",
    desc: "Risk management and capital preservation come before profits. Here is how Rovers Access trains students to manage losses gracefully and grow consistently.",
    cover: "../images/blog/b3.webp",
  },
  {
    id: 4,
    type: "Education",
    date: "MAR. 22, 2026",
    com: "4 COMMENTS",
    title: "Understanding Trend Analysis: Impulse, Correction & Swings",
    desc: "A trend is more than just a direction. Learn how to identify trend elements, distinguish impulse from correction, and find high-probability trade entries.",
    cover: "../images/blog/b4.webp",
  },
  {
    id: 5,
    type: "Student Story",
    date: "APR. 08, 2026",
    com: "9 COMMENTS",
    title: "From Zero to Consistent Trader — A Rovers Access Graduate Story",
    desc: "One of our students shares their journey from complete beginner to executing live trades confidently, and how the Signature Programme changed their financial outlook.",
    cover: "../images/blog/b5.webp",
  },
  {
    id: 6,
    type: "Market News",
    date: "MAY. 01, 2026",
    com: "6 COMMENTS",
    title: "Risk-to-Reward: The Single Most Important Concept in Trading",
    desc: "Before you enter any trade, understanding your risk-to-reward ratio is non-negotiable. We break down how to calculate it and why it is the foundation of profitable trading.",
    cover: "../images/blog/b6.webp",
  },
]

export const testimonal = [
  {
    id: 1,
    name: "JAMES MWANGI",
    post: "FOREX TRADER — NAIROBI",
    desc: "Before Rovers Access, I was gambling with my money and calling it trading. The Signature Programme completely changed my approach. I now trade with a plan, manage my risk, and sleep easy.",
    cover: "./images/testo/t1.webp",
  },
  {
    id: 2,
    name: "AMINA HASSAN",
    post: "UNIVERSITY STUDENT — KENYA",
    desc: "I enrolled with zero experience and was worried I wouldn't keep up. The small class size meant Mr. Ali always had time for my questions. I'm now trading a live account after just 8 weeks.",
    cover: "./images/testo/t2.webp",
  },
  {
    id: 3,
    name: "PETER OTIENO",
    post: "ENTREPRENEUR — WESTLANDS",
    desc: "The Professional Mentorship Programme gave me skills I use every day. The focus on risk management and trading psychology is what sets Rovers Access apart from every other course I've tried.",
    cover: "./images/testo/t3.webp",
  },
]
